module.exports = __webpack_public_path__ + "img/Chi_siamo_desktop.85d0c79a.jpg";